import DataDownload from "components/dataDownload/DataDownloadHomepage"

export default DataDownload